enum ConditionalSigningVersionEnum {
    Version1 = 'V1',
    Version2 = 'V2',
}

export default ConditionalSigningVersionEnum;
